/* LA GALERÍA DE OPINIONES — Cuadros Splash (22 sep 2026).

   QUÉ HAY DEBAJO, ANTES DE ESTE GUION
   El <ol class="cs-galeria__pista"> es un carrusel nativo: overflow-x con
   scroll-snap. Sin JavaScript se desliza con el dedo o con el trackpad y se
   ven las 74 opiniones enteras, con su imagen y su texto. Nada de lo que
   sigue hace falta para leerlas.

   QUÉ AÑADE ESTE GUION, por encima
   · Las flechas, el teclado (← → Inicio Fin) y el arrastre con el ratón.
   · El pase automático: cada N segundos pasa a la siguiente, con una línea
     fina que se va llenando bajo el escenario. Se para al pasar
     el ratón, al tocar, con el foco dentro, con la pestaña oculta, cuando
     la galería no está en pantalla, con el visor abierto y con el botón de
     pausa. Y no arranca si el visitante pide menos movimiento.
   · La línea de tiempo: un punto por opinión y el año sobre el primero de
     cada año. Se pinta aquí a partir de data-anio.
   · El contador, la entrada palabra a palabra de la cita (los <span> se
     ponen aquí; la animación está en el CSS bajo .is-activa), las
     miniaturas de las opiniones con varias fotos y el visor a pantalla
     completa (<dialog>).

   CÓMO SABE CUÁL ES LA ACTIVA
   Por el scroll: cada diapositiva mide el ancho de la pista, así que
   scrollLeft / ancho es el índice. Vale igual para el dedo, el trackpad,
   las flechas y el arrastre — una sola fuente de verdad. Mientras un
   desplazamiento programado va de camino (irA), los eventos de scroll
   intermedios se ignoran para que la cita no se reinicie a medias.

   LO QUE NO SE HACE Y POR QUÉ
   · No se usa GSAP ni ningún plugin: todo lo que se mueve aquí lo mueve el
     CSS (animaciones bajo .is-activa) o el scroll del navegador. Menos
     kilos y ninguna pelea con cs-cine.js, que no toca la galería.
   · No se ocultan las diapositivas que no se ven (ni display:none ni
     aria-hidden): están en un <ol> y un lector de pantalla las recorre como
     la lista que son.
   · No se usa import() dinámico: el minificador de Shopify lo convierte en
     require() y rompe el fichero entero (lección de cs-cine.js).
*/
(function () {
  'use strict';

  var REDUCIDO = window.matchMedia('(prefers-reduced-motion: reduce)');
  var visor = null;        /* el <dialog>, uno para toda la página */
  var visorEstado = null;

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------- las palabras de la cita ----------
     Cada palabra va en un <span> con su número (--i) para escalonar la
     entrada. Se respetan los <br> y los espacios: solo se envuelven los
     nodos de texto. Más allá de la palabra 60 entran todas a la vez, que
     nadie espera a que un párrafo termine de aparecer. */
  function partirEnPalabras(cita) {
    var textos = [];
    var paseo = document.createTreeWalker(cita, NodeFilter.SHOW_TEXT, null);
    while (paseo.nextNode()) textos.push(paseo.currentNode);
    var n = 0;
    textos.forEach(function (nodo) {
      var trozos = nodo.nodeValue.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      trozos.forEach(function (t) {
        if (!t) return;
        if (/^\s+$/.test(t)) {
          frag.appendChild(document.createTextNode(t));
          return;
        }
        var s = document.createElement('span');
        s.className = 'cs-galeria__palabra';
        s.style.setProperty('--i', String(Math.min(n, 60)));
        s.textContent = t;
        n++;
        frag.appendChild(s);
      });
      nodo.parentNode.replaceChild(frag, nodo);
    });
  }

  /* ---------- el visor a pantalla completa ---------- */
  function crearVisor() {
    var d = document.createElement('dialog');
    d.className = 'cs-visor';
    d.setAttribute('aria-label', csT('resenas.galeria.visor_label', 'Foto ampliada'));
    d.innerHTML =
      '<button type="button" class="cs-visor__cerrar" data-cs-visor-cerrar aria-label="' + escapar(csT('resenas.galeria.cerrar_visor', 'Cerrar la foto ampliada')) + '">&times;</button>' +
      '<button type="button" class="cs-visor__nav cs-visor__nav--atras" data-cs-visor-atras aria-label="' + escapar(csT('resenas.galeria.foto_anterior', 'Foto anterior')) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="cs-visor__escena" data-cs-visor-escena><img alt="" decoding="async" referrerpolicy="no-referrer"></div>' +
      '<button type="button" class="cs-visor__nav cs-visor__nav--adelante" data-cs-visor-adelante aria-label="' + escapar(csT('resenas.galeria.foto_siguiente', 'Foto siguiente')) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="cs-visor__pie"><p class="cs-visor__quien" data-cs-visor-quien></p><p class="cs-visor__cuenta" data-cs-visor-cuenta></p></div>';
    document.body.appendChild(d);

    d.addEventListener('click', function (e) {
      if (e.target === d || e.target.closest('[data-cs-visor-cerrar]')) cerrarVisor();
      else if (e.target.closest('[data-cs-visor-atras]')) moverVisor(-1);
      else if (e.target.closest('[data-cs-visor-adelante]')) moverVisor(1);
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); moverVisor(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); moverVisor(-1); }
      else if (e.key === 'Escape') { e.preventDefault(); cerrarVisor(); }
    });
    /* Esc lo cierra el propio <dialog>. La limpieza (soltar el scroll,
       devolver el foco, reanudar el pase) se engancha por TRES sitios y es
       idempotente: `cancel` (Esc, antes de cerrar), `close` (cualquier
       cierre) y la propia tecla. En el panel del navegador de Claude el
       evento close no llegó a dispararse nunca, y la página se quedaba con
       el scroll bloqueado: mejor sobrar que faltar. No se llama a
       preventDefault en `cancel`: Chrome lo ignora sin gesto del usuario. */
    d.addEventListener('cancel', function () { limpiarVisor(); });
    d.addEventListener('close', function () { limpiarVisor(); });

    /* Deslizar con el dedo para cambiar de foto. */
    var toque = null;
    var escena = d.querySelector('[data-cs-visor-escena]');
    escena.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      toque = { x: e.clientX, y: e.clientY };
    }, { passive: true });
    escena.addEventListener('pointerup', function (e) {
      if (!toque) return;
      var dx = e.clientX - toque.x;
      var dy = e.clientY - toque.y;
      toque = null;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4) moverVisor(dx < 0 ? 1 : -1);
    }, { passive: true });
    return d;
  }

  function abrirVisor(estado) {
    visor = visor || crearVisor();
    visorEstado = estado;
    visor.dataset.fotos = String(estado.fotos.length);
    pintarVisor();
    document.documentElement.classList.add('cs-visor-abierto');
    /* El scroll suave de la casa (Lenis) sigue escuchando la rueda aunque
       el <dialog> esté delante: se le para mientras el visor está abierto. */
    if (window.csLenis && typeof window.csLenis.stop === 'function') window.csLenis.stop();
    if (typeof visor.showModal === 'function') {
      if (!visor.open) visor.showModal();
    } else {
      visor.setAttribute('open', '');
    }
    if (estado.alAbrir) estado.alAbrir();
  }

  function pintarVisor() {
    if (!visorEstado) return;
    var f = visorEstado.fotos[visorEstado.n];
    var img = visor.querySelector('img');
    var quien = visor.querySelector('[data-cs-visor-quien]');
    var cuenta = visor.querySelector('[data-cs-visor-cuenta]');
    var dentro = f.querySelector('img');
    visor.classList.add('is-cargando');
    img.onload = img.onerror = function () { visor.classList.remove('is-cargando'); };
    img.src = f.getAttribute('href');
    img.alt = dentro ? dentro.alt : '';
    quien.innerHTML =
      '<strong>' + escapar(visorEstado.autor) + '</strong>' +
      (visorEstado.fecha ? ' · ' + escapar(visorEstado.fecha) : '') +
      (visorEstado.leyenda ? ' · ' + visorEstado.leyenda : '');
    cuenta.textContent = (visorEstado.n + 1) + ' / ' + visorEstado.fotos.length;
  }

  function moverVisor(paso) {
    if (!visorEstado || visorEstado.fotos.length < 2) return;
    var n = visorEstado.fotos.length;
    visorEstado.n = ((visorEstado.n + paso) % n + n) % n;
    pintarVisor();
  }

  function cerrarVisor() {
    if (!visor) return;
    if (visor.open && typeof visor.close === 'function') visor.close();
    else visor.removeAttribute('open');
    limpiarVisor();
  }

  function limpiarVisor() {
    var estado = visorEstado;
    visorEstado = null;
    if (!estado) return; /* ya limpio: no hay nada que soltar dos veces */
    document.documentElement.classList.remove('cs-visor-abierto');
    if (window.csLenis && typeof window.csLenis.start === 'function') window.csLenis.start();
    if (estado.disparador && typeof estado.disparador.focus === 'function') estado.disparador.focus({ preventScroll: true });
    if (estado.alCerrar) estado.alCerrar();
  }

  /* ---------- una galería ---------- */
  function montar(raiz) {
    if (raiz.dataset.csLista === 'si') return;
    var pista = raiz.querySelector('[data-cs-pista]');
    if (!pista) return;
    var diapos = Array.prototype.slice.call(pista.querySelectorAll('[data-cs-diapo]'));
    if (!diapos.length) return;
    raiz.dataset.csLista = 'si';
    raiz.classList.add('is-lista', 'is-dormida');

    var total = diapos.length;
    var actual = -1;
    var salidaActual = raiz.querySelector('[data-cs-actual]');
    var salidaTotal = raiz.querySelector('[data-cs-total]');
    var botonPausa = raiz.querySelector('[data-cs-pausa]');
    var linea = raiz.querySelector('[data-cs-linea]');
    var puntos = [];
    var puntosAnio = {};

    var segundos = parseFloat(raiz.dataset.segundos) || 7;
    var quiereAuto = raiz.dataset.auto !== 'no' && !REDUCIDO.matches;
    var pausadoAMano = false;
    var visible = false;
    var encima = false;
    var conFoco = false;
    var visorAbierto = false;
    var temporizador = null;
    var arranque = 0;
    var restante = segundos * 1000;
    var objetivo = null;     /* índice al que va un scroll programado */
    var objetivoReloj = null;
    var arrastre = null;
    var evitarClick = false;
    var ojo = null;
    var anchoConocido = pista.clientWidth;
    var ESTRECHO = window.matchMedia('(max-width: 749px)');

    if (salidaTotal) salidaTotal.textContent = String(total);
    raiz.style.setProperty('--g-segundos', segundos + 's');
    if (!quiereAuto) raiz.classList.add('is-manual');

    /* Las palabras. Con menos movimiento no se parte nada: el texto entra
       de golpe, que es lo que se ha pedido. */
    if (!REDUCIDO.matches) {
      diapos.forEach(function (d) {
        var cita = d.querySelector('[data-cs-cita]');
        if (cita) partirEnPalabras(cita);
      });
    }

    /* «Leer la opinión entera» en las largas. En escritorio el botón no se
       ve (la columna se desplaza sola); en el móvil recorta a cinco líneas. */
    diapos.forEach(function (d) {
      var cita = d.querySelector('.cs-galeria__cita--larga');
      if (!cita) return;
      cita.classList.add('is-recortada');
      var boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'cs-galeria__leer';
      boton.textContent = csT('resenas.galeria.leer_entera', 'Leer la opinión entera');
      boton.setAttribute('aria-expanded', 'false');
      boton.addEventListener('click', function () {
        var abierta = !cita.classList.toggle('is-recortada');
        boton.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        boton.textContent = abierta
          ? csT('resenas.galeria.leer_menos', 'Leer menos')
          : csT('resenas.galeria.leer_entera', 'Leer la opinión entera');
        ajustarAlto();
      });
      cita.insertAdjacentElement('afterend', boton);
    });

    function recortarDeNuevo(d) {
      var cita = d.querySelector('.cs-galeria__cita--larga');
      var boton = d.querySelector('.cs-galeria__leer');
      if (!cita || !boton) return;
      cita.classList.add('is-recortada');
      boton.setAttribute('aria-expanded', 'false');
      boton.textContent = csT('resenas.galeria.leer_entera', 'Leer la opinión entera');
    }

    /* ---------- dónde estamos ---------- */
    function indicePorScroll() {
      var ancho = pista.clientWidth || 1;
      return Math.max(0, Math.min(total - 1, Math.round(pista.scrollLeft / ancho)));
    }

    /* Un viaje programado: los scroll intermedios no cuentan hasta llegar
       (o hasta que pase un tiempo prudente, por si el dedo lo interrumpe). */
    function apuntarA(destino) {
      objetivo = destino;
      window.clearTimeout(objetivoReloj);
      objetivoReloj = window.setTimeout(function () { objetivo = null; }, 1400);
    }

    /* En el móvil las opiniones van en columna y cada una mide lo suyo: la
       pista toma la altura de la ACTIVA (con transición), en vez de la de la
       más larga de las 74. En escritorio la altura es fija y esto no toca. */
    function ajustarAlto() {
      if (!ESTRECHO.matches || actual < 0) { pista.style.height = ''; return; }
      pista.style.height = diapos[actual].offsetHeight + 'px';
    }

    function marcar(i, forzar) {
      if (i === actual && !forzar) return;
      var anterior = actual;
      actual = i;
      diapos.forEach(function (d, k) {
        if (k === i) {
          /* quitar y volver a poner reinicia las animaciones de entrada */
          d.classList.remove('is-activa');
          void d.offsetWidth;
          d.classList.add('is-activa');
        } else {
          d.classList.remove('is-activa');
        }
      });
      if (anterior >= 0 && anterior !== i) recortarDeNuevo(diapos[anterior]);
      /* el botón, al de la foto que esté activa en esta opinión */
      var marcoActivo = diapos[i].querySelector('[data-cs-marco]');
      if (marcoActivo) sincronizarBoton(diapos[i], marcoActivo.querySelector('[data-cs-foto].is-activa') || marcoActivo.querySelector('[data-cs-foto]'));
      if (salidaActual) salidaActual.textContent = String(i + 1);
      ajustarAlto();
      pintarLinea(i);
      reiniciarPase();
    }

    function irA(i) {
      var destino = ((i % total) + total) % total;
      var salto = actual >= 0 && Math.abs(destino - actual) > 1;
      var suave = !salto && !REDUCIDO.matches;
      apuntarA(destino);
      if (salto) {
        /* del final al principio (o un salto largo desde la línea de
           tiempo): sin recorrido, con un fundido corto */
        pista.classList.add('is-salto');
        pista.scrollTo({ left: destino * pista.clientWidth, behavior: 'auto' });
        /* setTimeout y no requestAnimationFrame: en una pestaña oculta rAF
           no corre, y la pista se quedaría invisible hasta volver a ella. */
        window.setTimeout(function () { pista.classList.remove('is-salto'); }, 60);
      } else {
        pista.scrollTo({ left: destino * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      }
      marcar(destino);
    }

    var esperaScroll = null;
    pista.addEventListener('scroll', function () {
      if (esperaScroll) return;
      esperaScroll = window.requestAnimationFrame(function () {
        esperaScroll = null;
        if (arrastre && arrastre.movido) return;
        /* En medio de un cambio de ancho el navegador recorta el scroll a lo
           que cabe y eso NO es que el visitante se haya movido: lo recoloca
           el manejador de resize. */
        if (pista.clientWidth !== anchoConocido) return;
        var i = indicePorScroll();
        if (objetivo !== null) {
          if (i === objetivo) { objetivo = null; window.clearTimeout(objetivoReloj); }
          return;
        }
        marcar(i);
      });
    }, { passive: true });

    /* Si el visitante toca o gira la rueda, cualquier viaje programado deja
       de mandar: manda el dedo. */
    function sueltaObjetivo() { objetivo = null; window.clearTimeout(objetivoReloj); }
    pista.addEventListener('touchstart', sueltaObjetivo, { passive: true });
    pista.addEventListener('wheel', sueltaObjetivo, { passive: true });

    /* Al cambiar el ancho (girar el móvil), la pista vuelve a la opinión en
       la que estaba: el scroll-snap ya lo intenta solo, esto lo asegura. */
    var esperaMedida = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(esperaMedida);
      esperaMedida = window.setTimeout(function () {
        anchoConocido = pista.clientWidth;
        ajustarAlto();
        if (actual < 0) return;
        apuntarA(actual);
        pista.scrollTo({ left: actual * pista.clientWidth, behavior: 'auto' });
      }, 120);
    });

    /* ---------- flechas y teclado ---------- */
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-cs-atras]'), function (b) {
      b.addEventListener('click', function () { irA(actual - 1); });
    });
    Array.prototype.forEach.call(raiz.querySelectorAll('[data-cs-adelante]'), function (b) {
      b.addEventListener('click', function () { irA(actual + 1); });
    });
    pista.addEventListener('keydown', function (e) {
      if (e.altKey || e.ctrlKey || e.metaKey) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(actual + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); irA(actual - 1); }
      else if (e.key === 'Home') { e.preventDefault(); irA(0); }
      else if (e.key === 'End') { e.preventDefault(); irA(total - 1); }
    });

    /* ---------- arrastrar con el ratón ----------
       Solo ratón: el dedo ya arrastra solo. Mientras se arrastra se quita
       el imán (clase is-arrastrando) y al soltar se decide: más de un 12 %
       del ancho, pasa a la siguiente; menos, vuelve. Y el clic que suelta
       el ratón no abre nada. */
    pista.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      arrastre = { id: e.pointerId, x: e.clientX, scroll: pista.scrollLeft, desde: actual, movido: false };
    });
    pista.addEventListener('pointermove', function (e) {
      if (!arrastre || e.pointerId !== arrastre.id) return;
      var dx = e.clientX - arrastre.x;
      if (!arrastre.movido) {
        if (Math.abs(dx) < 6) return;
        arrastre.movido = true;
        pista.classList.add('is-arrastrando');
        try { pista.setPointerCapture(e.pointerId); } catch (err) { /* da igual */ }
      }
      pista.scrollLeft = arrastre.scroll - dx;
      e.preventDefault();
    });
    function soltar(e) {
      if (!arrastre || (e && e.pointerId !== undefined && e.pointerId !== arrastre.id)) return;
      var a = arrastre;
      arrastre = null;
      if (!a.movido) return;
      pista.classList.remove('is-arrastrando');
      evitarClick = true;
      window.setTimeout(function () { evitarClick = false; }, 50);
      var dx = e ? e.clientX - a.x : 0;
      var umbral = pista.clientWidth * 0.12;
      var destino = a.desde + (dx < -umbral ? 1 : dx > umbral ? -1 : 0);
      destino = Math.max(0, Math.min(total - 1, destino));
      irA(destino);
    }
    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointercancel', soltar);
    pista.addEventListener('lostpointercapture', function () { if (arrastre && arrastre.movido) soltar(null); });
    pista.addEventListener('click', function (e) {
      if (evitarClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    /* ---------- las miniaturas y las fotos rotas ---------- */
    function elegirFoto(marco, n) {
      var fotos = marco.querySelectorAll('[data-cs-foto]');
      var minis = marco.querySelectorAll('[data-cs-mini]');
      Array.prototype.forEach.call(fotos, function (f, k) { f.classList.toggle('is-activa', k === n); });
      Array.prototype.forEach.call(minis, function (m, k) {
        m.classList.toggle('is-activa', k === n);
        m.setAttribute('aria-pressed', k === n ? 'true' : 'false');
      });
      sincronizarBoton(marco.closest('[data-cs-diapo]'), fotos[n]);
    }

    /* El botón "Ver este cuadro" sigue a la foto: cuando una opinión enseña
       dos cuadros distintos (r00: la menina y las orquídeas), cada foto lleva
       su propio data-cs-cuadro y el botón apunta al que se está viendo. Si la
       foto no trae cuadro propio, el botón se queda con el de la opinión. */
    function sincronizarBoton(diapo, foto) {
      if (!diapo || !foto) return;
      var boton = diapo.querySelector('[data-cs-ver]');
      if (!boton) return;
      var url = foto.getAttribute('data-cs-cuadro');
      if (url) boton.setAttribute('href', url);
    }

    pista.addEventListener('click', function (e) {
      var mini = e.target.closest ? e.target.closest('[data-cs-mini]') : null;
      if (!mini) return;
      var marco = mini.closest('[data-cs-marco]');
      if (marco) elegirFoto(marco, parseInt(mini.getAttribute('data-cs-mini'), 10) || 0);
    });

    /* Una foto de Google puede dejar de servirse cualquier día. Si falla, se
       pasa a la siguiente de esa opinión; si no queda ninguna, la opinión
       se queda con el texto solo, como la que no tenía foto. */
    pista.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var foto = img.closest('[data-cs-foto]');
      var mini = img.closest('[data-cs-mini]');
      if (mini) { mini.hidden = true; return; }
      if (!foto) return;
      foto.classList.add('is-rota');
      var marco = foto.closest('[data-cs-marco]');
      if (!marco) return;
      var todas = marco.querySelectorAll('[data-cs-foto]');
      var vivas = marco.querySelectorAll('[data-cs-foto]:not(.is-rota)');
      var k = Array.prototype.indexOf.call(todas, foto);
      var miniRota = marco.querySelector('[data-cs-mini="' + k + '"]');
      if (miniRota) miniRota.hidden = true;
      if (!vivas.length) {
        var d = marco.closest('[data-cs-diapo]');
        marco.hidden = true; /* sin ninguna foto viva, la opinión se queda con su texto */
        if (d) {
          d.classList.remove('cs-galeria__diapo--con-foto');
          d.classList.add('cs-galeria__diapo--sin-foto');
        }
      } else if (foto.classList.contains('is-activa')) {
        elegirFoto(marco, Array.prototype.indexOf.call(todas, vivas[0]));
      }
    }, true);

    /* ---------- el visor ---------- */
    pista.addEventListener('click', function (e) {
      var foto = e.target.closest ? e.target.closest('[data-cs-foto]') : null;
      if (!foto) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return; /* abrir en pestaña nueva se respeta */
      e.preventDefault();
      var marco = foto.closest('[data-cs-marco]');
      var diapo = foto.closest('[data-cs-diapo]');
      if (!marco || !diapo) return;
      var fotos = Array.prototype.slice.call(marco.querySelectorAll('[data-cs-foto]:not(.is-rota)'));
      var n = Math.max(0, fotos.indexOf(foto));
      var autor = diapo.querySelector('.cs-galeria__autor');
      var fecha = diapo.querySelector('.cs-galeria__fecha');
      var leyenda = marco.querySelector('.cs-galeria__leyenda');
      abrirVisor({
        fotos: fotos,
        n: n,
        autor: autor ? autor.textContent : '',
        fecha: fecha ? fecha.textContent : '',
        leyenda: leyenda ? leyenda.innerHTML : '',
        disparador: foto,
        alAbrir: function () { visorAbierto = true; pararPase(); },
        alCerrar: function () { visorAbierto = false; seguirPase(); }
      });
    });

    /* ---------- el pase automático ---------- */
    function puedePasar() {
      return quiereAuto && !pausadoAMano && visible && !encima && !conFoco && !visorAbierto &&
        document.visibilityState === 'visible';
    }

    function pararPase() {
      if (temporizador) {
        window.clearTimeout(temporizador);
        temporizador = null;
        restante = Math.max(400, restante - (performance.now() - arranque));
      }
      raiz.classList.add('is-quieta');
    }

    function seguirPase() {
      if (!puedePasar()) { raiz.classList.add('is-quieta'); return; }
      raiz.classList.remove('is-quieta');
      if (temporizador) return;
      arranque = performance.now();
      temporizador = window.setTimeout(function () {
        temporizador = null;
        restante = segundos * 1000;
        irA(actual + 1);
      }, restante);
    }

    function reiniciarPase() {
      if (temporizador) { window.clearTimeout(temporizador); temporizador = null; }
      restante = segundos * 1000;
      /* quitar y volver a poner reinicia la barra del pase */
      raiz.classList.remove('is-contando');
      void raiz.offsetWidth;
      raiz.classList.add('is-contando');
      seguirPase();
    }

    raiz.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      encima = true;
      pararPase();
    });
    raiz.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      encima = false;
      seguirPase();
    });
    raiz.addEventListener('focusin', function () { conFoco = true; pararPase(); });
    raiz.addEventListener('focusout', function (e) {
      if (e.relatedTarget && raiz.contains(e.relatedTarget)) return;
      conFoco = false;
      seguirPase();
    });
    pista.addEventListener('touchstart', pararPase, { passive: true });
    pista.addEventListener('touchend', function () {
      /* al soltar el dedo, el scroll marca la opinión nueva y eso reinicia
         el pase; si no se movió, se sigue donde estaba */
      window.setTimeout(seguirPase, 250);
    }, { passive: true });

    function alCambiarVisibilidad() {
      if (document.visibilityState === 'visible') seguirPase();
      else pararPase();
    }
    document.addEventListener('visibilitychange', alCambiarVisibilidad);

    if (botonPausa) {
      botonPausa.addEventListener('click', function () {
        pausadoAMano = !pausadoAMano;
        botonPausa.setAttribute('aria-pressed', pausadoAMano ? 'true' : 'false');
        botonPausa.setAttribute('aria-label', pausadoAMano
          ? csT('resenas.galeria.reanudar', 'Reanudar el pase automático')
          : csT('resenas.galeria.pausar', 'Pausar el pase automático'));
        if (pausadoAMano) pararPase();
        else reiniciarPase();
      });
    }

    /* ---------- la línea de tiempo ---------- */
    function montarLinea() {
      if (!linea) return;
      var caja = document.createElement('div');
      caja.className = 'cs-galeria__puntos';
      var anioPrevio = null;
      diapos.forEach(function (d, k) {
        var anio = d.getAttribute('data-anio') || '';
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cs-galeria__punto';
        b.setAttribute('aria-label', (anio
          ? csT('resenas.galeria.ir_opinion_anio', 'Ir a la opinión {n} de {total}, de {anio}').replace('{anio}', anio)
          : csT('resenas.galeria.ir_opinion', 'Ir a la opinión {n} de {total}')
        ).replace('{n}', String(k + 1)).replace('{total}', String(total)));
        if (anio && anio !== anioPrevio) {
          b.classList.add('cs-galeria__punto--anio');
          b.setAttribute('data-anio', anio);
          var eti = document.createElement('span');
          eti.className = 'cs-galeria__anio-eti';
          eti.textContent = anio;
          b.appendChild(eti);
          puntosAnio[anio] = b;
          anioPrevio = anio;
        }
        b.addEventListener('click', function () { irA(k); });
        caja.appendChild(b);
        puntos.push(b);
      });
      linea.appendChild(caja);
      linea.hidden = false;
    }

    function pintarLinea(i) {
      if (!puntos.length) return;
      puntos.forEach(function (b, k) {
        if (k === i) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
        b.classList.remove('is-actual');
      });
      var anio = diapos[i].getAttribute('data-anio');
      if (anio && puntosAnio[anio]) puntosAnio[anio].classList.add('is-actual');
      /* que el punto (o el año, en el móvil) se vea si la línea desborda */
      var b = puntos[i];
      if (b.offsetParent === null) b = puntosAnio[anio];
      if (!b || b.offsetParent === null) return;
      var izq = b.offsetLeft;
      var der = izq + b.offsetWidth;
      if (izq < linea.scrollLeft || der > linea.scrollLeft + linea.clientWidth) {
        linea.scrollTo({ left: Math.max(0, izq - linea.clientWidth / 2), behavior: REDUCIDO.matches ? 'auto' : 'smooth' });
      }
    }

    montarLinea();

    /* ---------- en pantalla / fuera de pantalla ---------- */
    if ('IntersectionObserver' in window) {
      ojo = new IntersectionObserver(function (entradas) {
        var esta = entradas[0].isIntersecting;
        if (esta && !visible) {
          visible = true;
          if (raiz.classList.contains('is-dormida')) {
            /* primera vez a la vista: ahora sí, con la entrada animada */
            raiz.classList.remove('is-dormida');
            marcar(indicePorScroll(), true);
          } else {
            seguirPase();
          }
        } else if (!esta && visible) {
          visible = false;
          pararPase();
        }
      }, { threshold: 0.3 });
      ojo.observe(raiz);
    } else {
      visible = true;
      raiz.classList.remove('is-dormida');
    }

    /* Punto de partida: la primera (o la que ya esté a la vista si el
       navegador restauró un scroll horizontal). Sin animación hasta que la
       galería entre en pantalla. */
    marcar(indicePorScroll(), true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajustarAlto);

    raiz._csDesmontar = function () {
      if (temporizador) window.clearTimeout(temporizador);
      window.clearTimeout(objetivoReloj);
      window.clearTimeout(esperaMedida);
      document.removeEventListener('visibilitychange', alCambiarVisibilidad);
      if (ojo) ojo.disconnect();
      delete raiz.dataset.csLista;
    };
  }

  function montarTodas(raiz) {
    Array.prototype.forEach.call((raiz || document).querySelectorAll('[data-cs-galeria]'), montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { montarTodas(); });
  } else {
    montarTodas();
  }

  /* El editor de temas vuelve a pintar la sección al cambiar un ajuste. */
  document.addEventListener('shopify:section:load', function (e) { montarTodas(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-cs-galeria]'), function (g) {
      if (g._csDesmontar) g._csDesmontar();
    });
  });
})();
